var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_c('source',{attrs:{"srcset":_vm.webpSrc,"type":"image/webp"}}),_c('img',{attrs:{"src":_vm.pngSrc,"alt":"Fast red car"}})])}
var staticRenderFns = []

export { render, staticRenderFns }